import React from "react";
import StatusBadge from "./StatusBadge";
import PriorityBadge from "./PriorityBadge";
import ProgressBar from "./ProgressBar";
import EmptyState from "./EmptyState";
import { isOverdue } from "./reportingStyles";

function NotesCell({ note }) {
  const text = note?.trim();
  if (!text) {
    return <span className="text-slate-400">—</span>;
  }

  return (
    <div className="daily-report-notes-cell whitespace-pre-wrap break-words text-slate-600 leading-relaxed">
      {text}
    </div>
  );
}

function ActivityTable({
  activities = [],
  showIndex = true,
  showEmployee = false,
  showProgress = true,
  showStatus = true,
  showNotes = true,
  onRowClick,
}) {
  if (activities.length === 0) {
    return <EmptyState message="No activities reported" />;
  }

  return (
    <div className="daily-report-table-wrap overflow-x-auto">
      <table className="daily-report-table w-full min-w-[640px] text-left text-xs">
        <thead className="bg-slate-50 text-[10px] font-semibold uppercase tracking-wide text-slate-500">
          <tr>
            {showIndex && <th className="px-3 py-2.5 w-10">#</th>}
            <th className="px-3 py-2.5">Task</th>
            {showEmployee && <th className="px-3 py-2.5">Employee</th>}
            <th className="px-3 py-2.5">Priority</th>
            {showProgress && <th className="px-3 py-2.5">Progress</th>}
            {showStatus && <th className="px-3 py-2.5">Status</th>}
            {showNotes && <th className="min-w-[220px] px-3 py-2.5">Notes</th>}
          </tr>
        </thead>
        <tbody>
          {activities.map((task, idx) => {
            const overdue = isOverdue(task);
            return (
              <tr
                key={task.id}
                onClick={() => onRowClick?.(task)}
                className={`border-t border-slate-50 align-top hover:bg-indigo-50/30 ${
                  onRowClick ? "cursor-pointer" : ""
                }`}
              >
                {showIndex && (
                  <td className="px-3 py-3 text-slate-400">{idx + 1}</td>
                )}
                <td className="px-3 py-3 font-medium text-slate-800">
                  {task.description || "—"}
                  {overdue && (
                    <span className="ml-2 rounded bg-rose-50 px-1.5 py-0.5 text-[10px] font-semibold text-rose-600">
                      Overdue
                    </span>
                  )}
                </td>
                {showEmployee && (
                  <td className="px-3 py-3 text-slate-600">
                    {task.user?.name || "—"}
                  </td>
                )}
                <td className="px-3 py-3">
                  <PriorityBadge priority={task.priority} />
                </td>
                {showProgress && (
                  <td className="px-3 py-3">
                    <ProgressBar
                      value={task.progress_percent || 0}
                      status={task.status}
                    />
                  </td>
                )}
                {showStatus && (
                  <td className="px-3 py-3">
                    <StatusBadge status={task.status} />
                  </td>
                )}
                {showNotes && (
                  <td className="px-3 py-3">
                    <NotesCell note={task.note} />
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ActivityTable;
